const InputWithActionButton = ({
  labelName,
  srOnlyLabel = true,
  buttonLabel = "Search",
  buttonType = "button",
  ariaLabel,
  placeholder,
  onChange = () => false,
  action,
}) => {
  return (
    <div className="mt-1 flex flex-col-reverse">
      <div className="w-full ">
        <div className="flex items-center">
          <label
            htmlFor={ariaLabel}
            className={`mb-1 ${srOnlyLabel && "sr-only"}`}
          >
            {labelName}
          </label>
        </div>

        <div className="flex flex-row">
          <div className="flex flex-col relative w-full">
            <input
              id={ariaLabel}
              className="pl-8 rounded-r-none"
              placeholder={placeholder}
              onChange={onChange}
              autoComplete="off"
            />
            <svg
              className="ui-icon text-theme-action w-4 h-4 absolute ml-2 mt-3"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-search" />
            </svg>
          </div>
          <button
            type={buttonType}
            className="ui-btn-primary rounded-l-none"
            onClick={() => (buttonType === "button" ? action() : () => false)}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InputWithActionButton;
